export const selectLocationsState = (state) => state.locations;

export const selectLocations = (state) =>
  state.locations.locations;
